(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var popup = document.getElementById('ys-welcome-popup');
    if (!popup) return;

    var state = popup.getAttribute('data-state');
    var dismissed = localStorage.getItem('ysWelcomeDismissed');
    var subscribed = localStorage.getItem('ysWelcomeSubscribed');

    function open() {
      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('is-open');
      });
      document.body.classList.add('ys-scroll-lock');
    }

    function close() {
      popup.classList.remove('is-open');
      document.body.classList.remove('ys-scroll-lock');
      setTimeout(function () {
        popup.hidden = true;
      }, 250);
    }

    var closers = popup.querySelectorAll('[data-ys-welcome-close]');
    for (var i = 0; i < closers.length; i++) {
      closers[i].addEventListener('click', function () {
        localStorage.setItem('ysWelcomeDismissed', '1');
        close();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) {
        localStorage.setItem('ysWelcomeDismissed', '1');
        close();
      }
    });

    var copyBtn = popup.querySelector('[data-ys-welcome-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var codeEl = popup.querySelector('[data-ys-welcome-code]');
        var code = codeEl ? codeEl.textContent.trim() : '';
        if (navigator.clipboard && code) {
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.textContent = 'COPIED';
            setTimeout(function () {
              copyBtn.textContent = 'COPY CODE';
            }, 1800);
          });
        }
      });
    }

    if (state === 'success') {
      localStorage.setItem('ysWelcomeSubscribed', '1');
      open();
      return;
    }

    if (dismissed || subscribed) return;

    setTimeout(open, 7000);
  });
})();
